<template>
  <div class="page">
    <div class="main-content">
      <vue-headful
        title="EVAPAPA | Contact"
        description="Contact Evangeline today."
      />
      <Nav />
      <MobileNav />
      <div class="full-width-container">
        <h1>CONTACT EVANGELINE</h1>
      </div>
      <div class="contact-container" style="margin-top: 40px;">
        <div class="contact-grid">
          <div class="left">TWITTER</div>
          <div class="center-mobile">
            <a
              href="https://twitter.com/evangelinepapan"
              class="right body-link"
              >@evangelinepapan</a
            >
          </div>
          <div class="left">LINKEDIN</div>
          <div class="center-mobile">
            <a
              href="https://www.linkedin.com/in/evangelinepapanicola/"
              class="right body-link"
              >linkedin.com/in/evangelinepapanicola/</a
            >
          </div>
          <div class="left">INSTAGRAM</div>
          <div class="center-mobile">
            <a
              href="https://www.instagram.com/evangelinepapanicola/"
              class="right body-link"
              >@evangelinepapanicola</a
            >
          </div>
        </div>
        <img
          alt="Business Cards"
          class="contact-image"
          src="../assets/businesscards.jpg"
        />
      </div>
      <div class="centered-container" style="margin-top:80px">
        <a class="cv-button" href="pdf/CV.pdf" target="_blank" rel="noopener"
          >DOWNLOAD MY CV</a
        >
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from "@/components/Nav.vue";
import MobileNav from "@/components/MobileNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Nav,
    MobileNav,
    Footer
  }
};
</script>
